import { Grid } from "@material-ui/core";
import { DEFAULT_BOX_SHADOW } from "App/constants";
import { formatNumber } from "App/utils/helpers";
import React from "react";

function DataCount({dataError}) {
  return (
    <div className='count-card'>
      <Grid container spacing={2}>
        <Grid item sm={12} md={3}>
          <MemberCountCard
            title={"JUMLAH STOK MINUS"}
            total={formatNumber(dataError.hasil_minus.length)}
          />
        </Grid>
        <Grid item sm={12} md={3}>
          <MemberCountCard
            title={"JUMLAH QTY INVALID"}
            total={formatNumber(dataError.qty_inventory_invalid.length)}
          />
        </Grid>
        <Grid item sm={12} md={3}>
          <MemberCountCard
            title={"JUMLAH INVENTORY TERHAPUS"}
            total={formatNumber(dataError.inventory_terhapus.length)}
          />
        </Grid>
        <Grid item sm={12} md={3}>
          <MemberCountCard
            title={"TOTAL DATA INVALID"}
            total={formatNumber(
                      parseInt(dataError?.hasil_minus?.length??0) + parseInt(dataError?.qty_inventory_invalid?.length??0) + parseInt(dataError?.inventory_terhapus?.length??0))}
          />
        </Grid>
      </Grid>
    </div>
  );
}

const MemberCountCard = ({ title, total }) => {
  return (
    <div
      className='member-count'
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: "#fff",
        minHeight: "130px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "8px",
        boxShadow: DEFAULT_BOX_SHADOW,
        position: "relative",
      }}>
      <div className=''>
        {" "}
        <p
          style={{
            position: "absolute",
            top: "10%",
            right: "5%",
            fontWeight: 600,
            fontSize: "14px",
            color: "#333",
          }}>
          {title}
        </p>
        <p
          style={{
            color: "#296218",
            fontSize: "2.5vw",
            fontWeight: 600,
            marginTop: "1.3rem",
          }}>
          {total}
        </p>
      </div>
    </div>
  );
};

export default DataCount;
